import React from 'react'
import {Model} from 'helpers'
import {Button} from 'helpers/ui-components/Button'
import {FormDataType} from 'models/ViewOrganisation'

type Props = {
 show: boolean
 onClose: () => void
 data: FormDataType | null
 onEdit?: () => void
}

const OrganisationPreviewModal: React.FC<Props> = ({
 show,
 onClose,
 data,
 onEdit,
}) => {
 return (
  <Model
   show={show}
   showHeader={false}
   header=''
   close={onClose}
   modelClass='md:w-[600px]'
   modelContainerClass='!rounded-xl'
   modelBodyClass='p-6'
  >
   <div>
    <div className='text-xl font-semibold mb-4'>
     Organisation Details
    </div>

    <div className='grid grid-cols-2 gap-4 text-sm'>
     <div>
      <p className='text-gray-500'>Name</p>
      <p className='font-medium'>{data?.name || '-'}</p>
     </div>

     <div>
      <p className='text-gray-500'>Type</p>
      <p className='font-medium'>
       {data?.type_name || data?.type || '-'}
      </p>
     </div>

     <div>
      <p className='text-gray-500'>State</p>
      <p className='font-medium'>
       {data?.state_name || '-'}
      </p>
     </div>

     <div>
      <p className='text-gray-500'>District</p>
      <p className='font-medium'>
       {data?.district_name || '-'}
      </p>
     </div>

     <div>
      <p className='text-gray-500'>Sub District</p>
      <p className='font-medium'>
       {data?.subDistrict_name || '-'}
      </p>
     </div>

     <div>
      <p className='text-gray-500'>PAN</p>
      <p className='font-medium'>
       {data?.pan_number || '-'}
      </p>
     </div>

     <div>
      <p className='text-gray-500'>GST</p>
      <p className='font-medium'>
       {data?.gst_number || '-'}
      </p>
     </div>

     <div>
      <p className='text-gray-500'>Pincode</p>
      <p className='font-medium'>{data?.pincode || '-'}</p>
     </div>

     <div className='col-span-2'>
      <p className='text-gray-500'>Address</p>
      <p className='font-medium'>
       {data?.full_address || '-'}
      </p>
     </div>
    </div>

    <div className='flex justify-end gap-3 mt-6'>
     <Button
      type='button'
      onClick={onClose}
      className='px-5 py-2 bg-[#4E83E4] text-white rounded-lg font-medium'
     >
      Close
     </Button>

     <Button
      type='button'
      onClick={onEdit}
      className='px-5 py-2 bg-[#4E83E4] text-white rounded-lg font-medium'
     >
      Edit
     </Button>
    </div>
   </div>
  </Model>
 )
}

export default OrganisationPreviewModal
